import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const Container = styled.section`
  display: grid;
  gap: 5px;
`;

export const StepperWrapper = styled.div`
  margin-top: 16px;
  padding: 25px 0;
  overflow-y: hidden;
  direction: rtl;

  ::-webkit-scrollbar {
    width: 4px;
    height: 12px;
    background: ${BaSeTheme.colors.institucionais.cinzaSebrae90};
    border-radius: 100px;
    cursor: pointer;
  }

  ::-webkit-scrollbar-thumb {
    background: ${BaSeTheme.colors.institucionais.azulSebrae36};
  }

  .BaSe--stepper {
    flex-direction: ${ (props) => props.position};
  }

  .BaSe--stepper-header {
    width: 150px;
  }

  .BaSe--stepper-container {
    flex-direction: row-reverse;
  }
`;

export const FormWrapper = styled.div`
  height: ${({isDesktop}) => isDesktop ? 'auto' : 'calc(100vh - 164px)'};
  overflow-y: auto;
  padding-right: 10px;
  .BaSe--input {
    margin-bottom: 10px;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 438px;
`;

export const ErrorWrapper = styled.div`
  section {
    position: relative;
  }
`;
